module.exports = [{
      plugin: require('/opt/build/repo/web/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Just a Girl from Oz Photography","short_name":"Just a Girl from Oz","description":"Beautiful photography crafted by an Aussie living in America.","start_url":"/","background_color":"#1a202c","theme_color":"#1d2330","display":"minimal-ui","icon":"src/images/logo-small.png"},
    },{
      plugin: require('/opt/build/repo/web/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
